<div class="feed__filter">
  <label class="feed__filter-label" for="communityFeedFilter">See content from</label>
  <span class="feed__select">
    <select id="communityFeedFilter" [(ngModel)]="feedType">
      <option value="followedOnly">People you follow</option>
      <option value="entireCommunity">Entire community</option>
    </select>
    <span class="material-icons" aria-hidden="true">expand_more</span>
  </span>
</div>

<div class="feed__list" [attr.aria-busy]="store.isLoading">
  @for (item of store.feedItems; track item.type + item.id) {
    <ut-community-feed-item [item]="item" [user]="user" (commented)="itemCommented.emit($event)" (deleted)="remove($event)"></ut-community-feed-item>
  }
</div>

@if (store.isLoading) {
  <ut-loading-dots></ut-loading-dots>
} @else if (store.feedItems.length && !store.isLastPage) {
  <!-- A button rather than infinite scroll, so keyboard users can get past the feed to the sidebar. -->
  <button type="button" class="ut-btn ut-btn--secondary feed__more" (click)="loadMore()">Load more posts</button>
}
